module.exports = {"513427101":"松新镇","513427102":"竹寿镇","513427103":"华弹镇","513427104":"白鹤滩镇","513427106":"西瑶镇","513427108":"大同镇","513427109":"骑骡沟镇","513427110":"跑马镇","513427111":"幸福镇","513427112":"石梨镇","513427113":"六铁镇","513427116":"宁远镇","513427117":"俱乐镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513427.json
// module id = 2568
// module chunks = 0